import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from 'shared';
import EditPrefillForm from '../forms/EditPrefillForm';
function EditPrefillModal({ isOpen, setIsOpen, onSubmit, initialValues, }) {
    return (_jsx(Modal, { isOpen: isOpen, setIsOpen: setIsOpen, withHandle: true, children: _jsx(EditPrefillForm, { onSubmit: onSubmit, onCancel: () => setIsOpen(false), initialValues: initialValues }) }));
}
export default EditPrefillModal;
